import dayjs from 'dayjs';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { AnalyticsUtils } from '@frontend/analytics-shared';
import { i18next } from '@frontend/i18n';
import { FilterValues } from '../filters/types';

export const CALL_INTEL_TIME_PERIODS = {
  today: {
    label: i18next.t('Today', { ns: 'analytics' }),
    value: AnalyticsUtils.findDatesRange({ range: 'day' }),
  },
  yesterday: {
    label: i18next.t('Yesterday', { ns: 'analytics' }),
    value: AnalyticsUtils.findDatesRange({ offset: 1, range: 'day' }),
  },
  thisWeek: {
    label: i18next.t('This Week', { ns: 'analytics' }),
    value: AnalyticsUtils.findDatesRange({ range: 'week' }),
  },
  thisMonth: {
    label: i18next.t('This Month', { ns: 'analytics' }),
    value: AnalyticsUtils.findDatesRange({ range: 'month' }),
  },
  lastWeek: {
    label: i18next.t('Last Week', { ns: 'analytics' }),
    value: AnalyticsUtils.findDatesRange({ offset: 1, range: 'week' }),
  },
  lastMonth: {
    label: i18next.t('Last Month', { ns: 'analytics' }),
    value: AnalyticsUtils.findDatesRange({ offset: 1, range: 'month' }),
  },
  last7Days: {
    label: i18next.t('Last 7 Days', { ns: 'analytics' }),
    value: AnalyticsUtils.findDatesRange({ offset: 7, range: 'day' }),
  },
  last30Days: {
    label: i18next.t('Last 30 Days', { ns: 'analytics' }),
    value: AnalyticsUtils.findDatesRange({ offset: 30, range: 'day' }),
  },
};

export const DEFAULT_CALL_INTEL_TIME_PERIOD = 'thisWeek';

/**
 * Filter keys that should be inherited by subviews from global filters.
 * These represent the base filtering context that subviews build upon.
 */
export const BASE_FILTER_KEYS = [
  'startDate',
  'endDate',
  'locations',
  'selectedTimePeriodKey',
  'contactTypes',
  'officeUsers',
  'officeHours',
] as (keyof FilterValues)[];

/**
 * Filter keys that should be synced bidirectionally between subview and global filters.
 * Changes to these keys in a subview will also update the global filters.
 */
export const BIDIRECTIONAL_FILTER_KEYS = [
  'startDate',
  'endDate',
  'locations',
  'selectedTimePeriodKey',
  'contactTypes',
  'officeUsers',
  'officeHours',
] as (keyof FilterValues)[];

/**
 * Filter keys whose values are scoped to specific locations (e.g., office user).
 */
export const LOCATION_DEPENDENT_FILTER_KEYS = ['officeUsers'] as (keyof FilterValues)[];

export const LOCAL_STORAGE_KEYS = {
  CALL_INTEL_UNSAVED_CHANGES_MODAL_PREF: 'CALL_INTEL_UNSAVED_CHANGES_MODAL_PREF',
};

export const VALID_CALL_INTEL_TABS: CallIntelTypes.CallIntelTab[] = ['overview', 'follow-up', 'records'];

/**
 * The earliest date from which Office Hours filtering is supported.
 * Date ranges that include dates before this cannot use Office Hours filters.
 */
export const OFFICE_HOURS_FILTER_SUPPORT_DATE = '2026-04-09';

export const FORMATTED_OFFICE_HOURS_SUPPORT_DATE = dayjs(OFFICE_HOURS_FILTER_SUPPORT_DATE).format('MMMM D, YYYY');
